import type { MarginHealth } from './types'
import { round2, safeNumber } from './math'

export class MarginCalculator {
  /** Margin % = profit / sale * 100 */
  marginPercent(profit: number, salePrice: number): number {
    const sale = safeNumber(salePrice)
    if (sale <= 0) return 0
    return round2((safeNumber(profit) / sale) * 100)
  }

  /** Markup % = profit / purchase * 100 */
  markupPercent(profit: number, purchasePrice: number): number {
    const purchase = safeNumber(purchasePrice)
    if (purchase <= 0) return 0
    return round2((safeNumber(profit) / purchase) * 100)
  }

  /** ROI % = profit / total cost * 100 */
  roiPercent(profit: number, totalCost: number): number {
    const cost = safeNumber(totalCost)
    if (cost <= 0) return 0
    return round2((safeNumber(profit) / cost) * 100)
  }

  health(marginPercent: number, profit: number, salePrice: number, purchasePrice: number): MarginHealth {
    if (profit < 0 || salePrice < purchasePrice || marginPercent < 0) return 'loss'
    if (marginPercent < 10) return 'low'
    return 'healthy'
  }
}
